/**
 * @generated SignedSource<<3327cffa610cdff890784f9b32f2c1d2>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type EstimatedDeliveryDateDisplay_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"shippingTrackingDetails_viewer">;
  readonly " $fragmentType": "EstimatedDeliveryDateDisplay_viewer";
};
export type EstimatedDeliveryDateDisplay_viewer$key = {
  readonly " $data"?: EstimatedDeliveryDateDisplay_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"EstimatedDeliveryDateDisplay_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "EstimatedDeliveryDateDisplay_viewer",
  "selections": [
    {
      "kind": "InlineDataFragmentSpread",
      "name": "shippingTrackingDetails_viewer",
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "LeadTime",
          "kind": "LinkedField",
          "name": "leadTimes",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "name",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "endTimeUnit",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "startTimeUnit",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "args": null,
      "argumentDefinitions": []
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "b014aef05457bd459b667c22d33523a7";

export default node;
